import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import SearchIcon from "@mui/icons-material/Search";
import Header from "../../Dashboard/Header";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
const PREFERENCE_KEY = "infiniteAppUserPreferences";

export default function VoucherTypeList() {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [pageSize, setPageSize] = useState(20);
  const [voucherTypes, setVoucherTypes] = useState([]);

  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  /* ───────── fetch voucher types ───────── */

  const fetchVoucherTypes = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/display/voucherType`,
        { cmpid },
        { headers: { Authorization: token } }
      );
      const voucherstypes = response.data.vchTypeMap[0].vchType;
      setVoucherTypes(voucherstypes);
      // console.log("data : ", voucherstypes);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchVoucherTypes();
  }, []);

  const handleRowClick = (params) => {
    const voucher = params.row;
    navigate(`/Infinite/DetailsVchType/${voucher.id}`);
  };

  // ==============================================

  const [searchQuery, setSearchQuery] = useState("");

  // Filter the users based on search query
  const filteredUsers = voucherTypes.filter((vch) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      vch.vchTypeName.toLowerCase().includes(searchLower) ||
      vch.vchTypeParent.toLowerCase().includes(searchLower)
    );
  });

  const VchListData = filteredUsers.map((vchs) => ({
    id: vchs.vchtypeId,
    vchTypeName: vchs.vchTypeName,
    vchTypeParent: vchs.vchTypeParent,
  }));

  const columns = [
    {
      field: "id",
      headerName: "Sr No",
      flex: 1,
      headerAlign:"left",
      align: "left",
      renderCell: (params) => params.api.getRowIndex(params.id) + 1,
    },

    {
      field: "vchTypeName",
      headerName: "Voucher Name",
      flex: 1,
      headerAlign:"left",
      align: "left"
    },
    {
      field: "vchTypeParent",
      headerName: "Parent",
      flex: 1,
      headerAlign:"left",
      align: "left",
    },
  ];

  return (
    <>
      <Box mt="70px" ml="0px" mr="20px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header title="Voucher Type" subtitle="All Voucher Type List" />
          <Box mt={1}>
            {/* Search Bar */}
            <TextField
              label="Search"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "35px",
                  padding: "0 8px",
                  "& fieldset": {
                    borderColor: colors.primary[120],
                  },
                  "&:hover fieldset": {
                    borderColor: colors.primary[100],
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: colors.primary[80],
                  },
                },
                "& .MuiInputLabel-root": {
                  color: colors.primary[120],
                  lineHeight: "20px",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: colors.primary[80],
                },
                color: colors.primary[120],
              }}
              InputLabelProps={{
                style: { color: colors.primary[100] },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end" sx={{ color: colors.primary[120] }}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Typography
              variant="body2"
              sx={{ fontStyle: "italic", color: "gray", mr: 1 }}
            >
              Note: Please click any row Voucher Type for Settings.
            </Typography>
          </Box>
        </Box>
        <Box
          height="78vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              cursor: "pointer",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
              color: colors.primary[150],
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
            },
            "& .MuiDataGrid-cell:focus": { outline: "none" },
            // ✅ Zoom on hover using a class
            "& .vchzoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          <DataGrid
            rows={VchListData}
            columns={columns}
            getRowId={(row) => row.id}
            onRowClick={handleRowClick}
            getRowClassName={() => "vchzoom-row"}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            rowHeight={27}
            headerHeight={30}
            componentsProps={{
              footer: {
                sx: {
                  height: 30,
                  minHeight: 30,
                },
              },
            }}
          />
        </Box>
      </Box>
    </>
  );
}
